import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('VITE_PUBLIC_SUPABASE_URL and VITE_PUBLIC_SUPABASE_ANON_KEY must be set');
}

const lockId = `supabase-auth-${Date.now()}-${Math.random()}`;

function acquireLock() {
  try {
    if (navigator.locks) {
      return new Promise<void>((resolve) => {
        navigator.locks.request(
          lockId,
          { timeout: 10000 },
          (lock) => {
            if (lock) {
              resolve();
            } else {
              resolve();
            }
          }
        );
      });
    }
  } catch {
    // Lock API not available, continue
  }
  return Promise.resolve();
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
  },
});

// Pre-acquire lock to avoid cross-tab contention
acquireLock().catch(() => {});